'use client';

import React from 'react';
import EventDTO from '../../models/event';
import WeekEventCard from '../WeekEventCard/WeekEventCard';
import { IconSmile2 } from '../icons';
import getCategoryIcon from '../../utils/getCategoryIcon';

interface Props {
  events: EventDTO[];
  onEventSelect: (eventId: string) => void;
  /** Cards rendered before the events (e.g. a featured festival), each already wrapped as a carousel item. */
  leading?: React.ReactNode[];
}

const ThisWeekEvents: React.FC<Props> = ({ events, onEventSelect, leading = [] }) => {
  if (events.length === 0 && leading.length === 0) {
    return null;
  }

  return (
    <section aria-label="Eventos de esta semana" className="flex flex-col gap-4">
      <div className="flex flex-row items-center gap-4">
        <h2 className="text-xl-semibold lg:display-md-semibold text-text-primary m-0">
          Esta semana
        </h2>
        <IconSmile2 className="w-10 h-10" />
      </div>

      <div
        className="
          grid grid-flow-col
          auto-cols-[80%] sm:auto-cols-[45%] lg:auto-cols-[31%] xl:auto-cols-[24%]
          gap-4 lg:gap-6
          overflow-x-auto
          snap-x snap-mandatory
          pt-2 pb-6
          [scrollbar-width:none] [&::-webkit-scrollbar]:hidden
        "
      >
        {leading}
        {events.map((event) => {
          // The BE returns the categories in assignment order; the card badges
          // the first one. Events without categories render no badge.
          const [category] = event.categories ?? [];
          const CategoryIcon = category ? getCategoryIcon(category.slug) : undefined;
          return (
            <div key={event.id} className="snap-start">
              <WeekEventCard
                event={event}
                onSelect={onEventSelect}
                category={category}
                categoryIcon={CategoryIcon ? <CategoryIcon className="text-sm" /> : undefined}
              />
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default ThisWeekEvents;
